import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import { t } from 'ember-intl'
import { concat } from '@ember/helper'
import { formatValue } from 'teacher-ui-client/utils/format-value'

export interface CourseProgressCategoriesData {
  category: string
  questions_answered: number
  average_score: Nullable<number>
}

interface Args {
  tooltip: string
  categories: CourseProgressCategoriesData[]
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export const CourseProgressCategories: TOC<Signature> = <template>
  <div class="relative" ...attributes>
    {{#if @tooltip}}
      <span class="absolute top-1 right-1 print:hidden">
        <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-3 w-3 cursor-pointer" />
        <Tooltip @text={{@tooltip}} />
      </span>
    {{/if}}
    <table class="w-full overflow-hidden text-black">
      <thead class="bg-oceany-blue-100 border-b border-white">
        <tr>
          <th class="border-r border-white p-3">
            {{t "reporting.rex.courseProgressCategories.progress"}}
          </th>
          <th class="border-r border-white p-3">
            {{t "reporting.rex.courseProgressCategories.questions"}}
          </th>
          <th class="p-3">
            {{t "reporting.rex.courseProgressCategories.correct"}}
          </th>
        </tr>
      </thead>
      <tbody>
        {{#each @categories as |category|}}
          <tr class="even:bg-oceany-blue-50 hover:bg-oceany-blue-100 bg-white">
            <td class="p-3">
              {{! category needs to be the literal, actual category name in above type}}
              {{t (concat "reporting.rex.courseProgressCategories.categories." category.category)}}
            </td>
            <td class="p-3">
              {{category.questions_answered}}
            </td>
            <td class="p-3">
              {{formatValue category.average_score append="%"}}
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </div>
</template>

export default CourseProgressCategories
